import React from 'react'

type Props = { children: React.ReactNode, onClose: () => void }
const BottomDrawer: React.FC<Props> = ({ children, onClose }) => {
  return (
    <div className='w-screen h-[100dvh] bg-gray/50 backdrop-opacity-50 fixed top-0 right-0 z-40 no-doc-scroll'>
      <div className='w-screen h-full absolute top-0 right-0 z-50' onClick={onClose}></div>
      <div className='p-3 w-screen max-h-[90dvh] overflow-y-auto rounded-t-lg absolute bg-gray-300 bottom-0 right-0 z-50'>
        {children}
      </div>
    </div>
  )
}

export default BottomDrawer
